// =============================
// Imports
// =============================

// External Dependencies
import PropTypes from 'prop-types';

import { withTranslation } from '../../../config/i18n';

import { StyledSwitchInput } from './styles';

// =============================
// Component
// =============================

const SwitchInput = ({ t, ...rest }) => (
  <StyledSwitchInput
    lang={{
      Label: {
        optional: t('components:mewo_input.Label.optional'),
      },
    }}
    {...rest}
  />
);

SwitchInput.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation(['components'])(SwitchInput);
